module.exports = __webpack_public_path__ + "img/Schnitt quer.a2340fdc.jpg";